export const customerRouteParamName = ":customerId";
export const customersRoutePath = "/customers";
export const customerRoutePrefix = `${customersRoutePath}/${customerRouteParamName}`;
